export interface CourseSyllabus {
    courseId: string;
    courseName: string;
    courseDesc: string;
}

export interface ModuleSyllabus {
    moduleId: string;
    moduleName: string;
    unitsDto: Units[];

}

export interface Units {
    unitId: string;
    unitName: string;
    unitDesc: string;
    noOfChapters: number;
    noOfAssignments: number;
    chaptersDto: ChapterSyllabus[];
}


export interface ChapterSyllabus {
    chapterId: string;
    chapterName: string;
    noOfQuestions: number;
}

export interface ChapterSyllabusState {
    [id: string]: ChapterSyllabus;
}
export interface ModuleSyllabusState {
    [id: string]: ModuleSyllabus;
}
export interface CourseSyllabusState {
    [id: string]: CourseSyllabus;
}
export interface SyllabusStateType {
    courses: CourseSyllabusState;
    chapters: ChapterSyllabusState;
    modules: ModuleSyllabusState;
    program: ProgramSylabusState;
}
export interface ProgramSylabusState {
    programId: string;
    programName: string;
    programDesc: string;
}

export enum ActionTypes {
    FETCH_COURSE_SYLLABUS = 'FETCH_COURSE_SYLLABUS',
    FETCH_CHAPTER_SYLLABUS = 'FETCH_CHAPTER_SYLLABUS',
    FETCH_MODULE_SYLLABUS = 'FETCH_MODULE_SYLLABUS',

}